module.exports = __webpack_public_path__ + "media/images/icon/blue/ico_arrow_left-5f9f55ab798c9b7e61c71f7efecf4d68.svg";